import { makeStyles, createStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { blue, grey, indigo, lightBlue } from '@mui/material/colors';

import { useTheme } from '@mui/material';

export default makeStyles(() => {
  const theme = useTheme();
  const darkMode = theme.palette.mode === 'dark';

  return createStyles({
    '@global': {
      '.recharts-tooltip-cursor': {
        fill: darkMode ? grey[700] : grey[200],
      },
    },
    chartBox: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1,
      width: '100%',
      height: '100%',

      border: `1px solid ${darkMode ? grey[700] : grey[400]}`,
      backgroundColor: darkMode ? grey[800] : '#ffffff',
      borderRadius: 6,
    },
    chartTitle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',

      width: '100%',
      backgroundColor: darkMode ? grey[700] : blue[900],
      color: darkMode ? grey[200] : grey[100],
      borderTopLeftRadius: 6,
      borderTopRightRadius: 6,
      padding: 8,

      '& > span': {
        width: '100%',
        fontWeight: 'bold',
        textAlign: 'center',
      },
    },
    chartContent: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
      padding: 8,
    },
    chartDetails: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
      padding: 8,
      borderRadius: 6,
      borderColor: darkMode ? grey[600] : grey[400],
      borderTopStyle: 'solid',
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopWidth: 1,
      backgroundColor: darkMode ? '#4a4a4a' : '#ffffff',
    },
    tooltipChartContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      border: '1px solid',
      borderRadius: 6,
      borderColor: darkMode ? grey[900] : grey[400],
      backgroundColor: darkMode ? grey[700] : grey[100],
      minWidth: 156,
    },
    tooltipChartTitle: {
      width: '100%',
      textAlign: 'center',
      color: darkMode ? grey[200] : grey[700],
      backgroundColor: darkMode ? grey[800] : grey[100],
      padding: 8,
    },
    tooltipChartDataLabel: {
      color: darkMode ? grey[200] : grey[700],
    },
    tooltipChartDataValue: {},
    tooltipChartPlaned: {
      color: darkMode ? grey[200] : grey[700],
      padding: 8,

      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 2,
    },

    tooltipChartRealized: {
      color: darkMode ? grey[200] : grey[400],
    },
    tooltipChart: {
      backgroundColor: darkMode ? grey[800] : grey[100],
    },
    tooltipChartLabel: {
      color: darkMode ? grey[200] : grey[800],
    },
    detailsGrid: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      height: '100%',
      width: '100%',
      '& > :nth-child(even)': {
        backgroundColor: darkMode ? '#565656' : '#f1f1f1',
      },
      '& > :nth-child(odd)': {},
    },
    detailsContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      padding: '2px 8px',
      color: darkMode ? grey[300] : grey[800],
      fontSize: 13,
    },
  });
});
